/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSelector } from "@reduxjs/toolkit";
import { AppState } from "../..";
import { encode as base64Encode } from "base-64";
import { IfilterObj } from "../types";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const auditFilterSelector = (state: AppState) => state.auditFilter;

export const auditFilterAuditStatusSelector = (state: AppState) => state.auditFilter.selectedAuditStatus;
export const auditFilterUserNameSelector = (state: AppState) => state.auditFilter.selectedUserName;
export const auditFilterFromDateSelector = (state: AppState) => state.auditFilter.selectedFromDate;
export const auditFilterToDateSelector = (state: AppState) => state.auditFilter.selectedToDate;

export const urlParameterSelector = createSelector(
  auditFilterUserNameSelector,
  auditFilterAuditStatusSelector,
  auditFilterFromDateSelector,
  auditFilterToDateSelector,
  (userName, auditStatus, fromDate, toDate) => {
    const params = new URLSearchParams();
    const isEnableFilter = userName || auditStatus || fromDate || toDate;
    if (isEnableFilter) {
      const paramsString: IfilterObj = { type: "AND", operator: "", fieldName: "", value: "", predicates: [] };
      if (userName) {
        paramsString.predicates.push({ type: "", operator: "EQ", fieldName: "userid", value: userName, predicates: [{}] });
      }
      if (auditStatus) {

        auditStatus === "0" ? paramsString.predicates.push({ type: "", operator: "is_false", fieldName: "allowed", value: auditStatus, predicates: [{}] }) : 
        paramsString.predicates.push({ type: "", operator: "is_true", fieldName: "allowed", value: auditStatus, predicates: [{}] })

      }

      if (fromDate) {
        const fromDateMls = dayjs(fromDate).valueOf();
        paramsString.predicates.push({ type: "", operator: "GTE", fieldName: "date", value: fromDateMls.toString(), predicates: [{}] });
      }
      if (toDate) {
        const toDateMls = dayjs(toDate).valueOf();

        paramsString.predicates.push({ type: "", operator: "LTE", fieldName: "date", value: toDateMls.toString(), predicates: [{}] });
      }

      const base64EncodedStr = base64Encode(JSON.stringify(paramsString));
      base64EncodedStr && params.append("filters", base64EncodedStr);
      //console.log("Auditfilter:", base64Decode(base64EncodedStr));
    }
    return params;
  }
);
